<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-角色管理-修改
    -->
    <el-dialog
    title="修改角色"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
      <el-form-item label="名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入名称" class="max-w460"></el-input>
      </el-form-item>

      <el-form-item label="编码" prop="code">
        <el-input v-model="form.code" placeholder="请输入编码" class="max-w460"></el-input>
      </el-form-item>

      <el-form-item label="价格" prop="price">
        <el-input
          v-model="form.price"
          placeholder="请输入价格"
          class="max-w460"
          type="number"
          min="0"
          step="0.01"
        >
          <template slot="append">元</template>
        </el-input>
      </el-form-item>

      <el-form-item label="状态" prop="status">
        <el-switch v-model="form.status" active-text="启用" inactive-text="禁用"></el-switch>
      </el-form-item>
     <el-form-item label="预付款" prop="path" >
        <el-input v-model="form.yfk" placeholder="请输入预付款" class="max-w460"></el-input>元
      </el-form-item>
<!-- 
   <el-form-item label="结算价(平台标准价4,999元/账)" prop="path" >
        <el-input v-model="form.jsj" placeholder="请输入结算价" class="max-w460"></el-input>折
      </el-form-item> -->

         <el-form-item label="数量" prop="path" >
        <el-input v-model="form.num" placeholder="请输入数量" class="max-w460"></el-input>个
      </el-form-item>

             <el-form-item label="年度销售任务" prop="path" >
        <el-input v-model="form.saletask" placeholder="请输入年度销售任务" class="max-w460"></el-input>个
      </el-form-item>



<el-form-item label="状态" prop="status">
    <el-switch v-model="form.status" active-text="启用" inactive-text="禁用"></el-switch>
</el-form-item>

      <el-form-item label="排序" prop="sort">
        <el-input v-model="form.sort" placeholder="请输入排序" class="max-w460"></el-input>
      </el-form-item>

      <el-form-item label="主路径" prop="main_path">
        <el-input v-model="form.main_path" placeholder="请输入主路径" class="max-w460"></el-input>
      </el-form-item>

      <el-form-item label="订单详情路径" prop="order_detail_path">
        <el-input v-model="form.order_detail_path" placeholder="请输入订单详情路径" class="max-w460"></el-input>
      </el-form-item>

      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
    <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片
    </Upload>
    <!-- <Categoryas :isproduct="iscategorya" :excludeIds="excludeIds" :islist="false" @closeDialog="closeDialogFunc"></Categoryas> -->
  </div>
</el-dialog>
</template>

<script>
import UroleApi from '@/api/urole.js';
import Upload from '@/components/file/Upload';
import Categoryas from "@/components/categorya/index.vue";
import draggable from "vuedraggable";
import Uediter from '@/components/UE.vue';

export default {
  components: {
    /*图片上传*/
    Upload: Upload,
    Categoryas,
    draggable,
    Uediter
  },
  data() {
    // 价格验证规则
    const validatePrice = (rule, value, callback) => {
      if (!value && value !== 0) {
        return callback(new Error('请输入价格'));
      }
      // 转换为数字
      const priceValue = parseFloat(value);
      if (isNaN(priceValue)) {
        callback(new Error('价格必须为数字'));
      } else if (priceValue < 0) {
        callback(new Error('价格不能为负数'));
      } else if (priceValue > 100000000) {
        callback(new Error('价格不能超过1亿'));
      } else {
        // 验证小数位数
        const decimalPart = value.toString().split('.')[1];
        if (decimalPart && decimalPart.length > 2) {
          callback(new Error('价格最多保留两位小数'));
        } else {
          callback();
        }
      }
    };

    return {
      /*是否上传图片*/
      isupload: false,
      isImg: false,
      /*富文本配置*/
      ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      /*form表单数据*/
      form: {
        name: "",
        code: "",
        price: "", // 新增价格字段
        status: 1,
        sort: "",
        main_path: "",
        yfk:0,
        jsj:0,
        num:0,
        saletask:0,

      },
      loading: false,
      /*验证规则*/
      rules: {
        name: [
          { required: true, message: '请输入角色管理名称', trigger: 'blur' }
        ],
        price: [
          { required: true, message: '请输入价格', trigger: 'blur' },
          { validator: validatePrice, trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入编码', trigger: 'blur' }
        ],
        sort: [
          { pattern: /^\d+$/, message: '排序必须为整数', trigger: 'blur' }
        ]
      },
      dialogVisible: false,
      iscategorya: false,
      excludeIds: [],
      isProductUpload: false,
      code: "album",
      select_menu: [],
      roleList: [],
      data: []
    };
  },
  created() {
    console.log('角色管理修改页面初始化');
    this.dialogVisible = this.open_add;
    this.getDetail();
  },
  props: ["open_add", "user_role_id"],
  methods: {
    chooseCategory() {
      this.iscategorya = true;
    },

    /*上传*/
    openUpload(e) {
      this.isupload = true;
    },

    /*获取图片*/
    returnImgsFunc(e) {
      let self = this;
      if (e != null) {
        this.form.image_id = e[0].file_id;
        this.form.image = e[0].file_path;
        this.isImg = true;
      }
      this.isupload = false;
    },

    /*关闭弹窗*/
    dialogFormVisible(result) {
      this.$emit("close", {});
    },

    cancelFunc() { // 取消
      this.dialogFormVisible("error")
    },

    getDetail() {
      let self = this;
      // 取到路由带过来的参数
      UroleApi.detail({ user_role_id: self.user_role_id }, true)
        .then(data => {
          self.form = data.data.detail;
          self.form.status = self.form.status == 1 ? true : false;

          // 确保价格字段存在，如果没有则设置为空
          if (self.form.price === undefined || self.form.price === null) {
            self.form.price = "";
          }

          let obj = self.clearData(data.data.menu, data.data.select_menu);
          self.select_menu = data.data.select_menu;
          self.roleList = data.data.roleList;
          self.data = data.data.menu;

          if (self.form.parent_id == 0) {
            self.form.parent_id = 0 + '';
          }
        })
        .catch(error => {
          console.error('获取详情失败:', error);
        });
    },

    onSubmit() {
      let self = this;
      let form = self.form;
      form.user_role_id = self.user_role_id;
      form.status = form.status ? 1 : 0;

      // 处理价格字段，确保为数字
      if (form.price) {
        form.price = parseFloat(form.price);
      }

      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          UroleApi.edit(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("success")
            })
            .catch(error => {
              self.loading = false;
              console.error('提交失败:', error);
            });
        } else {
          console.log('表单验证失败');
          return false;
        }
      });
    },

    /*取消修改，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false, "type": "" });
    },

    openProductUpload: function(code) {
      this.isProductUpload = true;
      this.code = code
    },

    /*上传商品图片*/
    returnProductImgsFunc(e) {
      if (this.code == 'album') {
        if (e != null) {
          let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
          let prevent = false;
          console.log(typeof imgExpt);
          e.forEach((element) => {
            let data_array = element.file_path.split(".");
            let ext = data_array[data_array.length - 1];
            imgExpt.forEach((e) => {
              if (e === ext) {
                prevent = true
                return false
              }
            });
          });

          if (!prevent) {
            this.$message.error("图片类型有误,请选择正确的图片格式");
            return false;
          }

          let imgs = this.form.image.concat(e);
          this.$set(this.form, "image", imgs);
        }
      } else {
        if (e != null) {
          let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
          let prevent = false;
          console.log(typeof imgExpt);
          e.forEach((element) => {
            let data_array = element.file_path.split(".");
            let ext = data_array[data_array.length - 1];
            imgExpt.forEach((e) => {
              if (e === ext) {
                prevent = true
                return false
              }
            });
          });

          if (!prevent) {
            this.$message.error("图片类型有误,请选择正确的图片格式");
            return false;
          }

          let imgs = this.form.bannar.concat(e);
          this.$set(this.form, "bannar", imgs);
        }
      }

      this.isProductUpload = false;
    },

    /*删除商品图片*/
    deleteImg(index, code) {
      if (code == 'album') {
        this.form.image.splice(index, 1);
      } else if (code == 'bannar') {
        this.form.bannar.splice(index, 1);
      }
    },

    /*清理数据方法（如果存在）*/
    clearData(menu, select_menu) {
      // 这里实现数据清理逻辑
      // 根据您的实际需求实现
      return {};
    }
  }
};
</script>

<style scoped>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}

.max-w460 {
  max-width: 460px;
}

.pb50 {
  padding-bottom: 50px;
}

.common-button-wrapper {
  text-align: center;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #eee;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/urole/index/part/edit.vue